export type MeiaPhaseKey = 'p1' | 'p2' | 'p3' | 'p4' | 'p5';

export type MeiaTabKey = 'acr-matrix' | 'overview' | MeiaPhaseKey;

export const meiaPhaseSteps = [
  {
    description: 'Frame the operational problem, missions, and mission-level measures',
    key: 'p1',
    label: 'P1',
    name: 'Missions',
  },
  {
    description: 'Compose mission threads and define stage structure',
    key: 'p2',
    label: 'P2',
    name: 'Threads',
  },
  {
    description: 'Assign tasks to kill-chain stages',
    key: 'p3',
    label: 'P3',
    name: 'Tasks',
  },
  {
    description: 'Run cases, thread verdicts, and measurement matrix',
    key: 'p4',
    label: 'P4',
    name: 'Scoring',
  },
  {
    description: 'Brief assembly, sync matrix, and sign-off',
    key: 'p5',
    label: 'P5',
    name: 'DM Brief',
  },
] satisfies Array<{
  description: string;
  key: MeiaPhaseKey;
  label: string;
  name: string;
}>;

export const meiaTabOrder: MeiaTabKey[] = ['overview', 'p1', 'p2', 'p3', 'p4', 'p5', 'acr-matrix'];

export const isMeiaTabKey = (value: string): value is MeiaTabKey => (meiaTabOrder as string[]).includes(value);

/** Minimum trimmed query length before the ⌘K search palette queries the API. */
export const MEIA_SEARCH_MIN_QUERY_LENGTH = 2;

export const meiaRoute = {
  studies: '/meia/studies',
  studyAcrMatrix: (studyId: string): string => `/meia/${studyId}/acr-matrix`,
  studyOverview: (studyId: string): string => `/meia/${studyId}/overview`,
  studyTab: (params: { query?: Record<string, string>; studyId: string; tab: MeiaTabKey }): string => {
    const base = `/meia/${params.studyId}/${params.tab}`;
    if (!params.query) return base;
    const search = new URLSearchParams(params.query).toString();
    return search ? `${base}?${search}` : base;
  },
};
